// eslint-disable-next-line no-restricted-imports
import { MutationInput_ClientController_UpdateById_Input_Category as CategoryApi } from 'api/generated/graphql';
import { ClientCategoryType } from 'api/types/entity';
import { Maybe } from 'types/maybe';

const category: Record<ClientCategoryType, CategoryApi> = {
  [ClientCategoryType.NonResident]: CategoryApi.NonResident,
  [ClientCategoryType.Resident]: CategoryApi.Resident,
  [ClientCategoryType.AIFCParticipant]: CategoryApi.AifcParticipant,
  [ClientCategoryType.KazakhstanResidenceExceptAIFCParticipants]:
    CategoryApi.KazakhstanResidenceExceptAifcParticipants,
  [ClientCategoryType.CentralAsiaResidenceExceptKazakhstan]:
    CategoryApi.CentralAsiaResidenceExceptKazakhstan,
  [ClientCategoryType.AsiaResidenceExceptCentralAsia]:
    CategoryApi.AsiaResidenceExceptCentralAsia,
  [ClientCategoryType.EuropeResidence]: CategoryApi.EuropeResidence,
  [ClientCategoryType.AmericasResidence]: CategoryApi.AmericasResidence,
  [ClientCategoryType.AustraliaResidence]: CategoryApi.AustraliaResidence,
  [ClientCategoryType.AfricaResidence]: CategoryApi.AfricaResidence,
  [ClientCategoryType.RussianFederationResidence]:
    CategoryApi.RussianFederationResidence,
};

export const parseCategoryTypeParam = (
  data: Maybe<ClientCategoryType>
): CategoryApi | null => (data ? category[data] : null);
